import {SearchPostCode} from './SearchPostCode'
import {Core as PostCodeCore} from 'yubinbango-core2'

export class SearchPostCodeImpl implements SearchPostCode {
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  search(postCode: string, callBack: any): void {

    new PostCodeCore(postCode, callBack)

  }
}
